var map = {
	"./logo_cl/logo-10.png": 4915,
	"./logo_cl/logo-11.png": 9706,
	"./logo_cl/logo-12.png": 289,
	"./logo_cl/logo-1a.png": 9642,
	"./logo_cl/logo-2.png": 0,
	"./logo_cl/logo-4a.png": 6429,
	"./logo_cl/logo-5a.png": 8486,
	"./logo_cl/logo-7.png": 2013,
	"./logo_cl/logo-8.png": 4234,
	"./logo_cl/logo-9.png": 8339,
	"./logo_cl/logo_3a.png": 6834,
	"./logo_dark.png": 7898,
	"./logo_light.png": 9684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2273;